import React, { useEffect, useState } from "react";
import { Users, Wallet, TrendingUp, Coins, Inbox, AlertCircle, ArrowDownToLine, Scale, Download } from "lucide-react";
import { api } from "@/lib/api";
import { API_BASE } from "@/lib/api";
import { PageHeader, StatCard, fmtUSD } from "@/components/ui-bits";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);

  const download = (path) => { window.open(`${API_BASE}${path}`, "_blank"); };

  return (
    <div>
      <PageHeader title="Admin Overview" subtitle="Global SpectralX network metrics"
        action={
          <div className="flex flex-wrap gap-2">
            <button onClick={() => download("/admin/export/users")} data-testid="export-users"
              className="inline-flex items-center gap-1.5 px-3 py-2 text-xs uppercase tracking-wider rounded-lg bg-[#0A132A] border border-white/10 text-[#94A3B8] hover:border-[#00F0FF]/40 transition-all">
              <Download size={14} /> Users
            </button>
            <button onClick={() => download("/admin/export/withdrawals")} data-testid="export-withdrawals"
              className="inline-flex items-center gap-1.5 px-3 py-2 text-xs uppercase tracking-wider rounded-lg bg-[#0A132A] border border-white/10 text-[#94A3B8] hover:border-[#00F0FF]/40 transition-all">
              <Download size={14} /> Withdrawals
            </button>
          </div>
        }
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Total Users" value={stats?.total_users ?? 0} icon={Users} accent />
        <StatCard label="Total Funding" value={fmtUSD(stats?.total_funding)} icon={TrendingUp} />
        <StatCard label="Active Rewards (Net)" value={fmtUSD(stats?.total_rewards_generated)} icon={Coins} />
        <StatCard label="Total Reward Paid" value={fmtUSD(stats?.total_reward_paid)} icon={Coins} />
        <StatCard label="Total Withdrawals" value={fmtUSD(stats?.total_withdrawals)} icon={ArrowDownToLine} />
        <StatCard label="Total Deposits" value={fmtUSD(stats?.total_deposits)} icon={Wallet} />
        <div className="glass p-4 sm:p-5 neon-glow col-span-2 lg:col-span-3" data-testid="adjusted-liability-card">
          <div className="flex items-start justify-between gap-2">
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#94A3B8] font-bold">Adjusted Company Liability</div>
            <Scale size={16} className="text-[#00F0FF]" strokeWidth={1.6} />
          </div>
          <div className="font-display text-2xl sm:text-3xl font-black mt-2 sm:mt-3 text-[#00F0FF]">{fmtUSD(stats?.adjusted_liability)}</div>
          <div className="text-[10px] sm:text-xs text-[#94A3B8] mt-1">Total Funding − 50% of Reward Paid</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="glass p-6">
          <div className="flex items-center gap-2 text-[#FFC400] mb-2"><AlertCircle size={18} /> <span className="font-bold uppercase text-xs tracking-wider">Pending Deposits</span></div>
          <div className="font-display text-3xl font-black">{stats?.pending_deposits ?? 0}</div>
        </div>
        <div className="glass p-6">
          <div className="flex items-center gap-2 text-[#FFC400] mb-2"><AlertCircle size={18} /> <span className="font-bold uppercase text-xs tracking-wider">Pending Withdrawals</span></div>
          <div className="font-display text-3xl font-black">{stats?.pending_withdrawals ?? 0}</div>
        </div>
        <div className="glass p-6">
          <div className="flex items-center gap-2 text-[#00F0FF] mb-2"><Inbox size={18} /> <span className="font-bold uppercase text-xs tracking-wider">Open Tickets</span></div>
          <div className="font-display text-3xl font-black">{stats?.open_tickets ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
